import { PaletteOptions } from "@mui/material";

export enum ColourPaletteName {
  ItsOnlyGame = "ItsOnlyGame", // 2024
  Mindful = "Mindful", // 2025
  Brenda = "Brenda", // 2026?
  SugarGuard = "SugarGuard",
  IsThisPeak = "IsThisPeak",
  LuminousAggressive = "LuminousAggressive",
  LookItUp = "LookItUp",
  ToTheMoon = "ToTheMoon",
  RadDog = "RadDog"
}

export const colourPalettes: Record<ColourPaletteName, PaletteOptions> = {
  [ColourPaletteName.ItsOnlyGame]: {
    mode: "dark",
    primary: { main: "#aeea00" },
    secondary: { main: "#3b00ea" }
  },
  [ColourPaletteName.LuminousAggressive]: {
    mode: "dark",
    primary: { main: "#00eda6" },
    secondary: { main: "#ed003f" },
    success: { main: "#41c63f" },
    error: { main: "#ff6156" },
    warning: { main: "#f9ca0c" },
    info: { main: "#226ef9" }
  },
  [ColourPaletteName.SugarGuard]: {
    mode: "dark",
    primary: { main: "#2a9899" },
    secondary: { main: "#fbbccb" },
    success: { main: "#53b583" },
    error: { main: "#d45658" },
    warning: { main: "#d4b56b" },
    info: { main: "#c5d5ec" }
  },
  [ColourPaletteName.IsThisPeak]: {
    mode: "dark",
    primary: { main: "#2591bb" },
    secondary: { main: "#f8c537" },
    success: { main: "#80aa0a" },
    error: { main: "#d12a27" },
    warning: { main: "#ed8004" },
    info: { main: "#00a8ce" }
  },
  [ColourPaletteName.LookItUp]: {
    mode: "dark",
    primary: { main: "#c2a2fb" },
    secondary: { main: "#39ccd0" },
    success: { main: "#6db073" },
    error: { main: "#f96f57" },
    warning: { main: "#f9d85f" },
    info: { main: "#f895e5" }
  },
  [ColourPaletteName.ToTheMoon]: {
    mode: "dark",
    primary: { main: "#49f9d4" },
    secondary: { main: "#735af8" },
    success: { main: "#49f97b" },
    error: { main: "#f9496f" },
    warning: { main: "#e0f85a" },
    info: { main: "#2dade8" }
  },
  [ColourPaletteName.Brenda]: {
    mode: "dark",
    primary: { main: "#f895e5" },
    secondary: { main: "#39ccd0" },
    success: { main: "#6db073" },
    error: { main: "#f96f57" },
    warning: { main: "#f9d85f" },
    info: { main: "#c2a2fb" }
  },
  [ColourPaletteName.RadDog]: {
    mode: "dark",
    primary: { main: "#e54873" },
    secondary: { main: "#62bcaa" },
    success: { main: "#98c658" },
    error: { main: "#e7734c" },
    warning: { main: "#f2e340" },
    info: { main: "#6f7ddb" }
  },
  [ColourPaletteName.Mindful]: {
    mode: "dark",
    primary: { main: "#6a72dc" },
    secondary: { main: "#f640c6" },
    success: { main: "#4bd2c0" },
    error: { main: "#e57683" },
    warning: { main: "#f19964" },
    info: { main: "#59becf" }
  }
};
